export const DEFAULT_ERROR_MESSAGE = "Error";

export const getErrorMessage = (error: unknown) => {
    if (error) {
        if (typeof error === "string") {
            return error;
        }

        if (typeof error === "object" && "message" in error && error.message) {
            return error.message.toString();
        }
    }

    return DEFAULT_ERROR_MESSAGE;
};
